<template>
  <div id="app">
    <keep-alive include="kefu">
      <router-view/>
    </keep-alive>
    
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    window.showResult=(obj)=>{
      if(window.location.href.endsWith("/chart")){
          if(obj.hasOwnProperty(this.$store.state.currentCode)){
             let info =obj[this.$store.state.currentCode]
             if(info.win>0){
               this.$toast("恭喜盈利万岁"+info.win.toFixed(2)+"元")
             }
          }
      }
    };
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
 
}
.header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    height: 44px;
    background-color: #1d2243;
    line-height: 44px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
}
.hbox {
  display: flex;
  justify-content: space-around;
  text-align: left;
}
.green {
   color:green;
}
.login {
  height: 100vh;
  
}
</style>



// WEBPACK FOOTER //
// src/App.vue